import TypographyCnpj from './TypographyCnpj';

export default TypographyCnpj;
